var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-container"},[_vm._v("Willkommen!")])}
var staticRenderFns = []

export { render, staticRenderFns }